import { connect } from 'react-redux';

import {
    getTeamList,
    getUserList,
    isLoadingTeams,
    isLoadingUsers,
    selectAchievementProgressBulkPostingMessage,
    selectAchievementProgressDeletingMessage,
    selectAchievementProgressPostingMessage,
    selectAchievementsProgress,
    selectAchievementsTypes,
    selectAllAchievements,
    selectIsAchievementsProgressBulkPosting,
    selectIsAchievementsProgressDeleting,
    selectIsAchievementsProgressLoading,
    selectIsAchievementsProgressPosting,
    selectIsAchievementsTypesLoading,
    selectIsAllAchievementsLoading,
} from 'core/selectors';
import {
    deleteAchievementsProgress,
    getAchievementsProgress,
    getAchievementsTypes,
    getAllAchievements,
    patchAchievementsProgress,
    postAchievementsProgress,
    postAchievementsProgressBulk,
} from 'core/slices/achievements';
import { getTeams } from 'core/slices/teams';
import { getUsers } from 'core/slices/users';


import AchievementAssignment from '../../../components/hall/admin/AchievementAssignment';

export default connect(
    state => ({
        allAchievements: selectAllAchievements(state),
        isAllAchievementsLoading: selectIsAllAchievementsLoading(state),
        users: getUserList(state),
        teams: getTeamList(state),
        isTeamsLoading: isLoadingTeams(state),
        isUsersLoading: isLoadingUsers(state),
        achievementsProgress: selectAchievementsProgress(state),
        isAchievementsProgressLoading: selectIsAchievementsProgressLoading(state),
        achievementProgressPostingMessage: selectAchievementProgressPostingMessage(state),
        isAchievementsProgressPosting: selectIsAchievementsProgressPosting(state),
        achievementProgressDeletingMessage: selectAchievementProgressDeletingMessage(state),
        isAchievementsProgressDeleting: selectIsAchievementsProgressDeleting(state),
        achievementsTypes: selectAchievementsTypes(state),
        isAchievementsTypesLoading: selectIsAchievementsTypesLoading(state),
        achievementProgressBulkPostingMessage: selectAchievementProgressBulkPostingMessage(state),
        isPostingBulk: selectIsAchievementsProgressBulkPosting(state),
    }),
    {
        getUsers,
        getTeams,
        getAllAchievements,
        getAchievementsProgress,
        postAchievementsProgress,
        postAchievementsProgressBulk,
        patchAchievementsProgress,
        deleteAchievementsProgress,
        getAchievementsTypes,
    },
)(AchievementAssignment);
